const getters = {
    selectMenuIndex: state => state.setting.selectMenuIndex,
    user: state => state.user.userInfo,
    hasLogin:state => state.user.hasLogin
  }
  export default getters